import { Drawing } from "drawing";

function gridlineDwgs(item, polyface, layer) {
  let vers = [];
  let hors = [];

  const { xmin, ymin, xmax, ymax } = polyface.bbox;

  const xoff =
    item.data.reference_planes.x_offset?.value.toNumber("inches") || 0;
  let v = xmin + xoff;
  vers.push(v);
  item.data.reference_planes.vertical?.forEach((vgl) => {
    const val = vgl.value.toNumber("inches");
    v += val;
    vers.push(v);
  });

  const yoff =
    item.data.reference_planes.y_offset?.value.toNumber("inches") || 0;
  let h = ymin + yoff;
  hors.push(h);
  item.data.reference_planes.horizontal?.forEach((hgl) => {
    const val = hgl.value.toNumber("inches");
    h += val;
    hors.push(h);
  });

  let refPlanes = [];
  const height = ymax - ymin;
  const width = xmax - xmin;

  const ht = height * 0.05;
  const wt = width * 0.05;
  const ext = Math.max(ht, wt);

  const xm0 = xmin - ext;
  const xm1 = xmax + ext;
  const ym0 = ymin - ext;
  const ym1 = ymax + ext;

  vers.forEach((v, i) => {
    refPlanes.push(
      new Drawing().polyline([
        { x: v, y: ym1 },
        { x: v, y: ym0 },
      ]),
    );
  });

  hors.forEach((h, i) => {
    refPlanes.push(
      new Drawing().polyline([
        { x: xm0, y: h },
        { x: xm1, y: h },
      ]),
    );
  });

  return new Drawing().add(...refPlanes).layer(layer);
}

export default gridlineDwgs;
